module.exports = __webpack_public_path__ + "img/aufzugoMaintenanceBanner.ae233ff.webp";